import React, { useRef } from "react";
import { Card, CardBody, Row, Col, Button } from "reactstrap";
import { QRCodeSVG } from "qrcode.react";
import download from "../../assets/images/svg/download.svg";

const QRCodeView = ({ values }) => {
  if (!values) return null;

  const partnerId = values?.partnerIDs?.[0] || "";
  const qrRef = useRef();

  const pricingGroups =
    values?.attributes
      ?.filter((attr) => attr.attributeName === "PricingGroupId")
      ?.flatMap((attr) =>
        Array.isArray(attr.attributeValue)
          ? attr.attributeValue
          : [attr.attributeValue],
      ) || [];

  console.log("pricingGroups", pricingGroups);

  // Static UI content (for now)
  const staticData = [
    {
      title: "Standard Rate",
      rate: "$0.30/kWh",
      description: "Regular charging rate for standard hours",
    },
    {
      title: "Peak Hours",
      rate: "$0.45/kWh",
      description: "Premium rate during peak hours (8AM-8PM)",
    },
    {
      title: "Off-Peak",
      rate: "$0.20/kWh",
      description: "Discounted rate for off-peak hours",
    },
  ];

  return (
    <div className="container-fluid py-3 px-6">
      <h4 className="mb-3 fw-bold">{values.name}</h4>

      <div className="mb-3">
        <span
          className="d-inline-flex align-items-center gap-2 px-3 py-1"
          style={{
            backgroundColor: "#E6F4EA",
            color: "#2E7D32",
            borderRadius: "5px",
            fontSize: "14px",
            fontWeight: 500,
            width: "fit-content",
            whiteSpace: "nowrap",
          }}
        >
          {/* Ring Icon */}
          <span
            style={{
              width: "15px",
              height: "15px",
              backgroundColor: "#2E7D32",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span
              style={{
                width: "8px",
                height: "8px",
                backgroundColor: "#ffffff",
                borderRadius: "50%",
              }}
            ></span>
          </span>

          {values.adminStatus}
        </span>
      </div>

      <div className="mb-3">
        <h5 className="fw-bold">Pricing Groups</h5>
      </div>

      {pricingGroups.length === 0 && (
        <p className="text-muted">No Pricing Groups available</p>
      )}

      {pricingGroups.map((pgId, index) => {
        const qrValue = JSON.stringify({
          pricingGroupId: pgId,
          partnerId: partnerId,
        });

        const ui = staticData[index % staticData.length];

        return (
          <div className="mb-3 border rounded-1 p-3" key={index}>
            <CardBody>
              <Row className="align-items-start">
                {/* LEFT SIDE */}
                <Col xs={12} md={8}>
                  <div className="d-flex align-items-center mb-2">
                    <h5 className="fw-bold mb-0">{ui.title}</h5>
                    <span
                      className="badge ms-3 p-2 rounded-1"
                      style={{ backgroundColor: "#E9F0E9", color: "#276D20" }}
                    >
                      {pgId}
                    </span>
                  </div>

                  <p className="text-muted mb-2">{ui.description}</p>

                  <div className="d-flex gap-1 align-items-center">
                    <h6 className="fw-bold">Rate : </h6>

                    <h6 className="text-danger fw-bold">{ui.rate}</h6>
                  </div>
                </Col>

                {/* RIGHT SIDE QR */}
                <Col xs={12} md={4} className="text-center mt-3 mt-md-0">
                  <div className="p-3 border border-dark rounded-1 d-inline-block">
                    <QRCodeSVG
                      value={qrValue}
                      size={120}
                      ref={qrRef}
                      id={`qr-${pgId}`}
                    />
                  </div>

                  <div className="mt-2 small text-muted">{pgId}</div>

                  <Button
                    size="sm"
                    className="mt-2 text-white"
                    style={{
                      backgroundColor: "#FD7545",
                      borderColor: "#FD7545",
                    }}
                    onClick={() => {
                      const svg = document.getElementById(`qr-${pgId}`);

                      const svgData = new XMLSerializer().serializeToString(
                        svg,
                      );
                      const canvas = document.createElement("canvas");
                      const ctx = canvas.getContext("2d");

                      const img = new Image();

                      const svgBlob = new Blob([svgData], {
                        type: "image/svg+xml;charset=utf-8",
                      });

                      const url = URL.createObjectURL(svgBlob);

                      img.onload = () => {
                        canvas.width = 200;
                        canvas.height = 200;
                        ctx.drawImage(img, 0, 0);

                        URL.revokeObjectURL(url);

                        const pngUrl = canvas.toDataURL("image/png");

                        const a = document.createElement("a");
                        a.href = pngUrl;
                        a.download = `${pgId}.png`;
                        a.click();
                      };

                      img.src = url;
                    }}
                  >
                    <img src={download} alt="Download" /> Download
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </div>
        );
      })}
    </div>
  );
};

export default QRCodeView;
